import { HTTP } from './common'

export const PdfApi = {

  load_pdf(object) {

      return HTTP.post("pdf/load_pdf/", object,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }).then((response) => {
        return response.data;
      });
  },
  remove(id) {

      return HTTP.delete(`pdf/${id}/`).then((response) => {
        return response.data;
      });
  },

  save_change(object) {

      return HTTP.post("pdf/save_change/", object,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }).then((response) => {
        return response.data;
      });
  },

  create(object) {

      return HTTP.post("pdf/create_layout/", object,{
            headers: {
                'Content-Type': 'multipart/form-data'
            }
          }).then((response) => {
        return response.data;
      });
  },
  get_pdf_layout(source, date, person_id) {
      return HTTP.get(`pdf/get_pdf_layout/?source=${source}&date=${date}&person_id=${person_id}`).then((response) => {
        return response.data;
      });
  },
  set_selected(data) {
      return HTTP.post(`pdf/set_selected/`, data).then((response) => {
        return response.data;
      });
  },
  project_info(project_id) {

      return HTTP.get("pdf/project_info/?project_id="+project_id).then((response) => {
        return response.data;
      });
  },
  list(source, date, project_id) {

      return HTTP.get(`pdf/?source=${source}&date=${date}&project_id=${project_id}`).then((response) => {
        return response.data;
      });
  },
  get(id) {

      return HTTP.get(`pdf/${id}/`).then((response) => {
        return response.data;
      });
  },
  links(source, project_id, date) {

      return HTTP.get(`pdf/links/?project_id=${project_id}${source?`&source=${source}`:""}${date?`&date=${date}`:""}`).then((response) => {
        return response.data;
      });
  },


};
